import React from 'react';
import { CheckCircle, X } from 'lucide-react';
import { MaintenanceNotification } from '@/contexts/NotificationContext';
import { formatDistanceToNow, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { Button } from '@/components/ui/button';

interface CompletedMaintenanceNotificationToastProps {
  notification: MaintenanceNotification;
  onClose: () => void;
}

const CompletedMaintenanceNotificationToast: React.FC<CompletedMaintenanceNotificationToastProps> = ({ 
  notification, 
  onClose 
}) => {
  return (
    <div className="flex flex-col w-full max-w-sm bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="flex items-center justify-between p-4 bg-green-50 border-b border-green-100">
        <div className="flex items-center">
          <div className="p-2 rounded-full bg-green-100 text-green-600 mr-3">
            <CheckCircle className="h-6 w-6" />
          </div>
          <div>
            <h4 className="font-semibold text-base">¡Mantenimiento completado!</h4>
            <p className="text-sm text-green-700">{notification.screenName}</p>
          </div>
        </div>
        <Button 
          variant="ghost" 
          size="icon" 
          className="h-8 w-8 rounded-full hover:bg-green-100"
          onClick={onClose}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="p-4">
        {notification.screenLocation && (
          <p className="text-sm text-gray-600 mb-1">
            Ubicación: {notification.screenLocation}
          </p>
        )}
        
        <p className="text-xs text-gray-500 mt-2">
          Completado {formatDistanceToNow(parseISO(notification.completedAt || notification.createdAt), { addSuffix: true, locale: es })}
        </p>
      </div>
    </div>
  );
};

export default CompletedMaintenanceNotificationToast; 